<template>
  <div>
    <NuxtLayout>
      <div id="page_not_found">
        <section class="bg-cl-light-grey py35 px20">
          <div class="container" v-if="error">
            <h1>Dang</h1>

            <p v-if="error" class="mt20 mb20">
              <strong>[{{ error?.statusCode }}] {{ error.message }}</strong>
              <clientOnly>
                
              </clientOnly>
              <br />
              <span>{{ $t('errors.message_404') }}</span>
            </p>
          </div>
          <div></div>
        </section>
      </div>
    </NuxtLayout>
  </div>
</template>

<script lang="ts" setup>
import { useNuxtApp } from '#imports';
import { useStoryblokStore } from '@/stores/storyblok';
import { useCategoryStore } from '@/stores/category';
import { sendPageViewedEvent } from '@/resources/tracking';
const { $logger } = useNuxtApp();

const storyblokStore = useStoryblokStore();
const categoryStore = useCategoryStore();
const error = useError();

const STabbedEventGrid = defineAsyncComponent(() => import('@/components/Pages/ProductListing/STabbedEventGrid.vue'));

onServerPrefetch(async () => {
  await Promise.all(
    [storyblokStore.fetchGlobalComponents(), categoryStore.fetchCategories()].map((p) =>
      p.catch((e) => $logger.error(e))
    )
  );
});

onUnmounted(() => {
  clearError();
});
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  min-height: 500px;
}

#page_not_found {
  margin-top: 2rem;
}
</style>
